
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.745 11.648c0-.87-.077-1.51-.232-2.187H11.488v3.968h5.884c-.116.987-.755 2.457-2.187 3.464l-.02.135 3.174 2.458.213.02c2.032-1.858 3.194-4.607 3.194-7.858z","fill":"#4877BB"}}),_c('path',{attrs:{"d":"M11.488 22.099c2.884 0 5.303-.948 7.064-2.593l-3.367-2.613c-.91.62-2.11 1.064-3.697 1.064-2.825 0-5.225-1.858-6.077-4.432l-.116.02-3.29 2.554-.039.116a10.63 10.63 0 009.522 5.884z","fill":"#21A849"}}),_c('path',{attrs:{"d":"M5.411 13.525a6.347 6.347 0 01-.348-2.109c0-.735.135-1.452.348-2.11v-.135L2.082 6.578l-.116.058a10.825 10.825 0 00-1.142 4.8c0 1.722.407 3.348 1.142 4.799l3.445-2.71z","fill":"#FBBA10"}}),_c('path',{attrs:{"d":"M11.488 4.874c2.013 0 3.348.871 4.122 1.587l3.02-2.941C16.772 1.797 14.372.752 11.488.752c-4.18 0-7.78 2.4-9.541 5.884l3.445 2.69c.87-2.594 3.27-4.452 6.096-4.452z","fill":"#E73830"}})])
          )
        }
      }
    